module.exports = __webpack_public_path__ + "img/alpino-icon.21b701db.png";